enum DiscountTypeEnum {
  DEFAULT = 'DEFAULT',
  AUTO_DISCOUNT = 'AUTO_DISCOUNT',
  PRE_DISCOUNT = 'PRE_DISCOUNT'
}

export default DiscountTypeEnum;
